import { activeCompanyID } from "./local-auth"

const key = (companyID: string) => `cowork.agent.responseLanguage.${companyID}`

export function rememberCoworkResponseLanguage(companyID: string, value: string) {
  if (!companyID) return
  try {
    localStorage.setItem(key(companyID), value)
  } catch {
    // Server preferences remain available if browser storage is disabled.
  }
}

export function coworkResponseLocale(applicationLocale: string, companyID = activeCompanyID()) {
  try {
    const value = localStorage.getItem(key(companyID))
    if (value && value !== "app") return value
  } catch {
    // Use the application language when browser storage is unavailable.
  }
  return applicationLocale
}
